import { Grid, Paper } from '@mui/material';
import { SiTrackPage } from '../../components/si-track-page';
import InspectionsFilters from './inspections-filters';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSaveData } from '../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../api/workorders-api-key-store';
import Inspections from './inspections';
import InspectorsFilters from './inspectors-filters';
import { usersApiKeyStore } from '../../api/users-api-key-store';
import Inspectors from './inspectors';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { LoadingIndicator } from '../../components/loading-indicator.component';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
};

const convertToArray = (value: any): number[] => {
  if (!value) return [];

  return value
    .toString()
    .split(',')
    .map((id: string) => Number(id.trim()))
    .filter((id: any) => !isNaN(id));
};

const transformData = (data: any) => {
  return {
    customerID: data.customer?.customerID ?? null,
    divisions: data.divisions?.map((d: any) => d.divisionID) ?? [],
    inspectors: data.userIDs?.map((u: any) => u.userID) ?? [],
    marketAreas: data.marketAreaIDs?.map((m: any) => m.marketAreaID) ?? [],
    offices: data.officeIDs?.map((o: any) => o.officeID) ?? [],
    projects: data.projectIDs?.map((p: any) => p.projectID) ?? [],
    scheduledDateFrom: data.fromDate ?? null,
    scheduledDateTo: data.toDate ?? null,
    workOrderStatusIDs: data.workOrderStatusID?.map((d: any) => d.workOrderStatusID) ?? [],
    // workOrderStatusID: 2,
    workOrderNumber: data?.workOrderNumber ?? '',
  };
};

const transformDataForInspector = (data: any) => {
  return {
    skillsets: data.skillsetIDs.map((skill: any) => skill.skillsetID),
    equipments: data.equipmentIDs.map((eq: any) => eq.equipmentID),
    marketAreas: data.marketAreaIDs.map((ma: any) => ma.marketAreaID),
    inspectors: data.userIDs.map((user: any) => user.userID),
    divisions: data.divisionIDs?.map((d: any) => d.divisionID) ?? [],
    scheduledDateFrom: data.fromDateForInspector ?? null,
    scheduledDateTo: data.toDateForInspector ?? null,
    filterFromArea: 'schedulebalancing',
  };
};

export const ScheduleDragAndDrop = () => {
  const [searchParams] = useSearchParams();
  const { isLoading, data, mutateAsync } = useSaveData<any>(workOrdersApiKeyStore.workOrderInspections());
  const {
    isLoading: isLoadingInspector,
    data: inspectorData,
    mutateAsync: mutateAsyncInspector,
  } = useSaveData<any>(usersApiKeyStore.updateInspectors());

  const [inspectionsFilterState, setInspectionsFilterState] = useState({
    customer: Number(searchParams.get('customerID')) || '',
    officeIDs: convertToArray(searchParams.get('offices')) || [],
    projectIDs: convertToArray(searchParams.get('projects')) || [],
    marketAreaIDs: convertToArray(searchParams.get('marketAreas')) || [],
    userIDs: convertToArray(searchParams.get('inspectors')) || [],
    workOrderStatusID: convertToArray(searchParams.get('workOrderStatusID')) || [],
    fromDate: searchParams.get('dateFrom') ?? '',
    toDate: searchParams.get('dateTo') ?? '',
    divisions: convertToArray(searchParams.get('divisions')) || [],
    workOrderNumber: searchParams.get('workOrderNumber') ?? '',
  });

  const [inspectorFilter, setInspectorFilter] = useState({
    userIDs: [] as number[],
    marketAreaIDs: [] as number[],
    skillsetIDs: [] as number[],
    equipmentIDs: [] as number[],
    divisionIDs: [] as number[],
    fromDateForInspector: '',
    toDateForInspector: '',
  });

  const form = useReactHookForm({
    defaultValues: {
      customer: { customerID: inspectionsFilterState.customer, customerName: '' },
      officeIDs: inspectionsFilterState.officeIDs,
      projectIDs: inspectionsFilterState.projectIDs,
      marketAreaIDs: inspectionsFilterState.marketAreaIDs,
      userIDs: inspectionsFilterState.userIDs,
      workOrderStatusID: inspectionsFilterState?.workOrderStatusID,
      fromDate: inspectionsFilterState.fromDate,
      toDate: inspectionsFilterState.toDate,
      divisions: inspectionsFilterState.divisions,
      workOrders: [],
      keepScheduledDateasOriginal: false,
      workOrderNumber: inspectionsFilterState.workOrderNumber,
    },
  });

  const handleInspectionsFilterClick = () => {
    const filteredPayload = transformData(inspectionsFilterState);
    mutateAsync({ data: filteredPayload });
  };

  const handleInspectorFilterClick = () => {
    const filteredPayload = transformDataForInspector(inspectorFilter);
    mutateAsyncInspector({ data: filteredPayload });
  };

  const handleSubmit = async (data: any) => {};

  return (
    <SiTrackPage title="Schedule Balancing">
      <div className="innerContent noOuterBg">
        <Paper elevation={0} style={{ paddingLeft: '16px' }}>
          <ReactHookForm
            formName="BULK_SCHEDULING_FORM"
            onSubmit={handleSubmit}
            formContextProps={form}
            // isBusy={isLoading}
          >
            <Grid
              // container
              spacing={1.5}
              style={{ background: 'none', padding: '0', width: '100%' }}
            >
              {isLoading && <LoadingIndicator isLoading={isLoading} />}
              {isLoadingInspector && <LoadingIndicator isLoading={isLoadingInspector} />}
              <Grid item lg={12} sm={12} xl={12} xs={12} style={{ paddingTop: '24px' }}>
                <Grid container spacing={1} style={{ marginLeft: '0', marginRight: '0', width: '100%' }}>
                  <Grid container spacing={1} style={{ marginLeft: '0', marginRight: '0', width: '100%' }}>
                    <Grid
                      container
                      spacing={1}
                      lg={7.5}
                      sm={7.5}
                      xl={7.5}
                      xs={7.5}
                      style={{
                        marginLeft: '0',
                        marginRight: '0',
                        paddingLeft: '8px',
                        paddingRight: '16px',
                        borderRight: '2px solid #e2e2e2',
                      }}
                    >
                      <h3 style={{ width: '100%', marginBottom: '15px' }}>Inspection Filters</h3>
                      <Grid container spacing={1} lg={12} sm={12} xl={12} xs={12}>
                        <InspectionsFilters
                          inspectionsFilterState={inspectionsFilterState}
                          setInspectionsFilterState={setInspectionsFilterState}
                          handleInspectionsFilterClick={handleInspectionsFilterClick}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      lg={4.5}
                      sm={4.5}
                      xl={4.5}
                      xs={4.5}
                      style={{
                        paddingLeft: '16px',
                        paddingRight: '8px',
                        marginLeft: '0',
                        marginRight: '0',
                        display: 'block',
                      }}
                    >
                      <h3 style={{ width: '100%', marginBottom: '15px' }}>Inspector Filters</h3>
                      <Grid container spacing={1} lg={12} sm={12} xl={12} xs={12}>
                        <InspectorsFilters
                          handleInspectorFilterClick={handleInspectorFilterClick}
                          inspectorFilter={inspectorFilter}
                          setInspectorFilter={setInspectorFilter}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <DndProvider backend={HTML5Backend}>
                    <Grid
                      className="inspection-inspectorListWrapper"
                      item
                      lg={12}
                      sm={12}
                      xl={12}
                      xs={12}
                      style={{ padding: '8px' }}
                    >
                      <div
                        className="inspection-inspectorListContainer"
                        style={{
                          padding: '0',
                          background: '#fff',
                          borderRadius: '8px',
                          display: 'flex',
                          gap: '0px',
                          width: '100%', // Space between the sections
                        }}
                      >
                        {/* Inspections on the left */}

                        <Grid
                          className="inspections-listContainer"
                          sm={7.5}
                          container
                          spacing={1}
                          style={{
                            flex: 1,
                            borderRight: '2px solid #e2e2e2',
                            margin: 0,
                            padding: ' 16px 16px 16px 32px',
                            minHeight: '300px',
                            justifyContent: 'center',
                          }}
                        >
                          <Inspections
                            inspections={data?.data}
                            handleInspectionsFilterClick={handleInspectionsFilterClick}
                          />
                        </Grid>
                        {/* Vertical Divider */}

                        {/* Inspectors on the right */}
                        <Grid
                          className="inspectors-listContainer"
                          sm={4.5}
                          container
                          spacing={1}
                          style={{
                            flex: 1,
                            marginLeft: 0,
                            padding: '  16px 16px 16px 32px',
                            justifyContent: 'center',
                            marginTop: '0',
                          }}
                        >
                          <Inspectors
                            inspectors={inspectorData?.data}
                            handleInspectorFilterClick={handleInspectorFilterClick}
                            handleInspectionsFilterClick={handleInspectionsFilterClick}
                          />
                        </Grid>
                      </div>
                    </Grid>
                  </DndProvider>
                </Grid>
              </Grid>
            </Grid>
          </ReactHookForm>
        </Paper>
      </div>
    </SiTrackPage>
  );
};
